import { render, staticRenderFns } from "./fundsFlow.vue?vue&type=template&id=11420a24"
import script from "./fundsFlow.vue?vue&type=script&lang=js"
export * from "./fundsFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports